var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6665",
    "data-name": "Group 6665",
    transform: "translate(-832 -355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2528",
    "data-name": "Rectangle 2528",
    width: 24,
    height: 24,
    transform: "translate(832 355)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5385",
    "data-name": "Group 5385",
    transform: "translate(834 357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25602",
    "data-name": "Path 25602",
    d: "M19.95,17.138a.781.781,0,0,0-1.53.318.816.816,0,0,1-.165.684.794.794,0,0,1-.625.3H2.371a.794.794,0,0,1-.625-.3.816.816,0,0,1-.165-.684,8.632,8.632,0,0,1,8.213-6.835q.1,0,.207,0t.208,0a8.594,8.594,0,0,1,6.941,3.815.781.781,0,1,0,1.3-.87,10.162,10.162,0,0,0-5.266-4,5.312,5.312,0,1,0-6.359,0A10.161,10.161,0,0,0,.051,17.138,2.374,2.374,0,0,0,2.371,20H17.63a2.374,2.374,0,0,0,2.32-2.862ZM6.25,5.313a3.75,3.75,0,1,1,3.94,3.745l-.19,0-.189,0A3.755,3.755,0,0,1,6.25,5.313Z",
    transform: "translate(0)",
    fill: "#878a99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.408a0f8a15f921ade31a87c9e735f13b.svg";
export { ForwardRef as ReactComponent };